import React from 'react';
import { useSelector } from 'react-redux';

import { getViewForChart, getVisibleEntriesForView } from '../../redux/sonar/sonarSelectors';
import { Panel } from '../../components/layout/layout';
import WithToolbarWrapper from '../with-toolbar-wrapper/WithToolbarWrapper';
import ViewRadioGroup from '../view-radio-group/ViewRadioGroup';
import { SONAR_SECTIONS } from '../../constants';
// import RadialBars from '../../components/charts/apex/radial-bars/RadialBars';
import { SONAR_DATA_KEYS } from '../../utils/chart';
import Treemap from '../../components/charts/echarts/Treemap';

const CHART_INDEX = 0;

function Trust() {
  const view = useSelector(getViewForChart(SONAR_SECTIONS.TRUST, CHART_INDEX));

  const domainEntries = useSelector(getVisibleEntriesForView(view));

  return (
    <Panel>
      <WithToolbarWrapper>
        <ViewRadioGroup chartIndex={CHART_INDEX} section={SONAR_SECTIONS.TRUST} />

        {/* <RadialBars data={domainEntries} dataKey={SONAR_DATA_KEYS.TRUST} /> */}
        <Treemap data={domainEntries} dataKey={SONAR_DATA_KEYS.TRUST} showLegend={false} fullWidth isTrend />
      </WithToolbarWrapper>
    </Panel>
  );
}

export default Trust;
